document.addEventListener("DOMContentLoaded", function () {

function hideRecentSection() {
    document.querySelectorAll('.recently-viewed-container')
    .forEach(el => el.style.display = 'none');
}

function showRecentSection() {
    document.querySelectorAll('.recently-viewed-container')
    .forEach(el => el.style.display = '');
}

// Set Recently Viewed

function setRecentlyViewedPdp() {

    const dataEl = document.getElementById("recent-product-data");
    if (!dataEl) return;

    const pdpData = {
        productId : dataEl.dataset.productId,
        productTitle : dataEl.dataset.productTitle,
        productImg : dataEl.dataset.productImg,
        productPrice : dataEl.dataset.productPrice,
        productComparePrice : dataEl.dataset.productComparePrice,
        productCompareRaw : Number(dataEl.dataset.productCompareRaw),
        productPriceRaw : Number(dataEl.dataset.productPriceRaw),
        productUrl : dataEl.dataset.productUrl
    };

    const numberOfProduct = 6;
    const productArr = [pdpData];

    let oldData = [];

    try {
        const localData = localStorage.getItem('recently_viewed');

        if (!localData) {
            localStorage.setItem('recently_viewed', JSON.stringify(productArr));
            return;
        }

        oldData = JSON.parse(localData) || [];
    } catch(e) {
        console.log('Read storage failed', e);
        return;
    }

    const exists = oldData.some(p => p.productId == pdpData.productId);
    if (exists) return;

    if (oldData.length >= numberOfProduct) {
        oldData.shift();
    }

    oldData.push(pdpData);

    try {
        localStorage.setItem('recently_viewed', JSON.stringify(oldData));
    } catch(e) {
        console.log('Storage failed', e);
    }
}

// Get recent PDP

function getRecentPdp () {

    let pdpData = [];

    try {
        const stored = localStorage.getItem('recently_viewed');
        if (!stored) {
            hideRecentSection();
            return;
        }
        pdpData = JSON.parse(stored) || [];
    } catch(e) {
        console.log('Parse failed', e);
        hideRecentSection();
        return;
    }

    if (!pdpData.length) {
        hideRecentSection();
        return;
    }

    const currentEl = document.getElementById("recent-product-data");
    const currentId = currentEl ? currentEl.dataset.productId : null;

    const filtered = currentId
        ? pdpData.filter(p => p.productId != currentId)
        : pdpData;

    if (!filtered.length) {
        hideRecentSection();
        return;
    }

    const recentViewHtml = [];

    filtered.slice().reverse().slice(0, 5).forEach(function(item){

        const onSale = item.productCompareRaw > item.productPriceRaw;

        const priceHtml = onSale
            ? `<p class="c-productPrice">
                <span class="price-compare">${item.productComparePrice}</span>
                <span class="price-sale">${item.productPrice}</span>
               </p>`
            : `<p class="c-productPrice">${item.productPrice}</p>`;

        recentViewHtml.push(`
            <section class="recent-item">
                <div class="c-product">
                    <div class="c-product__img">
                        <a href="${item.productUrl}">
                            <img src="${item.productImg}" alt="${item.productTitle}" loading="lazy">
                        </a>
                    </div>

                    <h3 class="c-product__title">
                        <a href="${item.productUrl}">
                            ${item.productTitle}
                        </a>
                    </h3>

                    ${priceHtml}

                </div>
            </section>
        `);
    });

    document.querySelectorAll('.js-recentPdpBlock')
        .forEach(el => el.innerHTML = recentViewHtml.join(''));

    showRecentSection();
}

// Init slick only if more than 5 items
function initRecentSlickIfNeeded() {
    const blocks = document.querySelectorAll('.js-recentPdpBlock');

    blocks.forEach(block => {
        const itemCount = block.querySelectorAll('.recent-item').length;

        if (
            window.innerWidth < 1240 &&
            typeof $ !== "undefined" &&
            $.fn.slick &&
            !$(block).hasClass('slick-initialized')
        ) {
            $(block).slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: false,
                speed: 400,
                swipeToSlide: true,
                draggable: true,
                adaptiveHeight: false,

                responsive: [
                    {
                        breakpoint: 1240,
                        settings: { slidesToShow: 4 }
                    },
                    {
                        breakpoint: 992,
                        settings: { slidesToShow: 3 }
                    },
                    {
                        breakpoint: 768,
                        settings: { slidesToShow: 2 }
                    },
                    {
                        breakpoint: 480,
                        settings: { slidesToShow: 1.1 }
                    }
                ]
            });
        }
    });
}

// run after render
setRecentlyViewedPdp();
getRecentPdp();
initRecentSlickIfNeeded();

});
